import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service';

@Injectable({ providedIn: 'root' })
export class DocumentsService {
  constructor(private api: ApiService) {}

  // Get documents by project ID
  getDocumentsByProject(projectId: string, userId?: string, search?: string, projectModule?: string, sortOrder?: 'asc' | 'desc', limit: number = 8, offset: number = 0): Observable<{documents: any[]; totalCount: number}> {
    let url = `/documents/project/${projectId}`;
    if (userId) url += `?userId=${userId}`;
    if (search && search.trim() !== '') url += `&search=${encodeURIComponent(search)}`;
    if (projectModule) url += `&projectModule=${projectModule}`;
    if (sortOrder) url += `&sortOrder=${sortOrder}`;
    if (limit) url += `&limit=${limit}`;
    if (offset) url += `&offset=${offset}`;
    return this.api.get<{ documents: any[]; totalCount: number }>(url);
  }


    getDocumentById(id: string): Observable<any> {
      return this.api.get(`/documents/${id}`);
    }

  toggleFavorite(documentId: string, userId: string): Observable<any> {
    return this.api.post(`/favorites/document/${documentId}`, { userId });
  }
  
}
